import { useFrame } from "@react-three/fiber";
import React, { useRef, useState } from "react";

// Particle system for effects
export const ParticleSystem = ({
	position,
	color = "#ffffff",
	count = 8,
	active = false,
	paused = false,
}) => {
	const particlesRef = useRef();
	const [particles, setParticles] = useState([]);

	// Store position in a ref to avoid re-triggering effect on every render
	// (array props create new references each render)
	const positionRef = useRef(position);
	positionRef.current = position;

	React.useEffect(() => {
		if (active) {
			const pos = positionRef.current;
			const newParticles = Array.from({ length: count }, (_, i) => ({
				id: i,
				startPos: [pos[0], pos[1], pos[2]],
				velocity: [
					(Math.random() - 0.5) * 2,
					Math.random() * 3 + 1,
					(Math.random() - 0.5) * 2,
				],
				life: 1.0,
				decay: 0.02 + Math.random() * 0.02,
			}));
			setParticles(newParticles);
		}
	}, [active, count]);

	useFrame(() => {
		if (paused) return;
		if (particles.length > 0) {
			setParticles((prevParticles) =>
				prevParticles
					.map((particle) => ({
						...particle,
						startPos: [
							particle.startPos[0] + particle.velocity[0] * 0.016,
							particle.startPos[1] + particle.velocity[1] * 0.016,
							particle.startPos[2] + particle.velocity[2] * 0.016,
						],
						velocity: [
							particle.velocity[0] * 0.98,
							particle.velocity[1] - 0.1, // gravity
							particle.velocity[2] * 0.98,
						],
						life: particle.life - particle.decay,
					}))
					.filter((particle) => particle.life > 0),
			);
		}
	});

	return (
		<group ref={particlesRef}>
			{particles.map((particle) => (
				<mesh key={particle.id} position={particle.startPos}>
					<sphereGeometry args={[0.02, 6, 6]} />
					<meshStandardMaterial
						color={color}
						transparent
						opacity={particle.life}
						emissive={color}
						emissiveIntensity={0.5}
					/>
				</mesh>
			))}
		</group>
	);
};
